export default "__VITE_ASSET__Bd0mNHcz__"